import { useApiRead } from "source/shared/SessionApiResource"
import { useParams, useSearchParams } from "react-router-dom"
import { Helmet } from "react-helmet-async"
import { Error404, Icon } from "source/shared/components"
import { useQRCode } from "source/shared/QRCode"
import OpenGraphTags from "source/shared/OpenGraphTags"
import { Heading } from "@planningcenter/doxy-web"
import Form from "./Form"
import { useSession } from "source/shared/hooks/useSession"
import { redirectTo } from "source/shared/routingUtils"
import { useEffect } from "react"

export default function FormWrapper() {
  const { id } = useParams()
  const [searchParams] = useSearchParams()
  const url = buildFormUrl(id, searchParams)
  useQRCode()
  const {
    meta: { authenticated },
  } = useSession()

  const form = useApiRead(url)

  const login_required = form?.data?.attributes?.login_required
  useEffect(() => {
    if (login_required && !authenticated) {
      redirectTo(`/login?return=${window.location.href}`)
    }
  }, [authenticated, login_required])

  if (form.errors) return <Error404 />
  if (!form.data?.attributes) return null

  const pageTitle = form.data.attributes.name

  const { name, description, send_submission_notification_to_submitter } =
    form.data.attributes

  const {
    person,
    default_country_code,
    default_email_address,
    grades,
    phone_types,
    address_types,
    encrypted_param,
    submitted_by_email_address,
  } = form.meta || {}

  return (
    <>
      <OpenGraphTags
        title={pageTitle}
        description={form.data.attributes.og_form_description}
      />
      {form.data.attributes.accepting_submissions ? (
        <Form
          name={name}
          description={description}
          id={id}
          person={person}
          defaultCountryCode={default_country_code}
          defaultEmailAddress={default_email_address}
          phoneTypes={phone_types}
          grades={grades}
          addressTypes={address_types}
          encryptedParam={encrypted_param}
          sendSubmissionNotificationToSubmitter={
            send_submission_notification_to_submitter
          }
          submittedByEmailAddress={submitted_by_email_address}
        />
      ) : (
        <NotAcceptingSubmissions />
      )}
      <Helmet title={pageTitle} />
    </>
  )
}

const buildFormUrl = (id, searchParams) => {
  const email = searchParams.get("email")
  const _e = searchParams.get("_e")
  const query = new URLSearchParams()

  if (email) query.set("email", email)
  if (_e) query.set("_e", _e)

  return `/people/v2/forms/${id}${query.toString() ? `?${query}` : ""}`
}

function NotAcceptingSubmissions() {
  return (
    <div className="d-f ai-c fd-c">
      <Icon
        className="mb-2"
        style={{ fontSize: 32 }}
        symbol="general#x-circle"
      />
      <Heading level={2} text="This form is not accepting submissions" />
    </div>
  )
}
